import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function BasicDetails({ nextStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>Name of the State</label>
              <div class="custom-select">
                <select class="form-control" id="stateSelect" name="state">
                  <option value="" selected="">
                    Select State
                  </option>
                  <option value="Andaman and Nicobar">
                    Andaman and Nicobar
                  </option>
                  <option value="Andhra Pradesh">Andhra Pradesh</option>
                  <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                  <option value="Assam">Assam</option>
                  <option value="Bihar">Bihar</option>
                  <option value="Chandigarh">Chandigarh</option>
                  <option value="Chhattisgarh">Chhattisgarh</option>
                  <option value="The Dadra and Nagar Haveli and Daman and Diu">
                    The Dadra and Nagar Haveli and Daman and Diu
                  </option>
                  <option value="Delhi">Delhi</option>
                  <option value="Goa">Goa</option>
                  <option value="Gujarat">Gujarat</option>
                  <option value="Haryana">Haryana</option>
                  <option value="Himachal Pradesh">Himachal Pradesh</option>
                  <option value="Jammu &amp; Kashmir and Ladakh">
                    Jammu &amp; Kashmir and Ladakh
                  </option>
                  <option value="Jharkhand">Jharkhand</option>
                  <option value="Karnataka">Karnataka</option>
                  <option value="Kerala">Kerala</option>
                  <option value="Madhya Pradesh">Madhya Pradesh</option>
                  <option value="Maharashtra">Maharashtra</option>
                  <option value="Manipur">Manipur</option>
                  <option value="Meghalaya">Meghalaya</option>
                  <option value="Mizoram">Mizoram</option>
                  <option value="Nagaland">Nagaland</option>
                  <option value="Odisha">Odisha</option>
                  <option value="Puducherry">Puducherry</option>
                  <option value="Punjab">Punjab</option>
                  <option value="Rajasthan">Rajasthan</option>
                  <option value="Sikkim">Sikkim</option>
                  <option value="Tamil Nadu">Tamil Nadu</option>
                  <option value="Telangana">Telangana</option>
                  <option value="Tripura">Tripura</option>
                  <option value="Uttar Pradesh">Uttar Pradesh</option>
                  <option value="Uttarakhand">Uttarakhand</option>
                  <option value="West Bengal">West Bengal</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label>Name of the District</label>
              <div class="custom-select">
                <select class="form-control" id="stateSelect" name="state">
                  <option value="" selected="">
                    Select District
                  </option>
                  <option value="Rajasthan">Chennai</option>
                  <option value="Sikkim">Coimbatore</option>
                  <option value="Tamil Nadu">Namakkal</option>
                  <option value="Telangana">Madurai</option>
                  {/* <option value="Tripura">Salem</option> */}
                  <option value="Uttar Pradesh">Salem</option>
                  <option value="Uttarakhand">Trichy</option>
                  <option value="West Bengal">Thanjavur</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label>Cluster HQ</label>
              <input type="text" placeholder="Enter Cluster HQ" />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>Reporting Month</label>
              <div className="custom-select">
                <select class="form-control" id="monthSelect" name="month">
                  <option value="" selected="">
                    Select Reporting Month
                  </option>
                  <option value="January">January</option>
                  <option value="February">February</option>
                  <option value="March">March</option>
                  <option value="April">April</option>
                  <option value="May">May</option>
                  <option value="June">June</option>
                  <option value="July">July</option>
                  <option value="August">August</option>
                  <option value="September">September</option>
                  <option value="October">October</option>
                  <option value="November">November</option>
                  <option value="December">December</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label>Reporting Year</label>
              <div className="custom-select">
                <select class="form-control" id="yearSelect" name="year">
                  <option value="" selected="">
                    Select Reporting Year
                  </option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                  <option value="2031">2031</option>
                  <option value="2032">2032</option>
                  <option value="2033">2033</option>
                  <option value="2034">2034</option>
                  <option value="2035">2035</option>
                  <option value="2036">2036</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label>Name and Desig. of the reporting officer</label>
              <input type="text" placeholder="Enter Officer Name & Desig" />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>Contact Number</label>
              <input type="text" placeholder="Enter Contact Number" />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label>Email address</label>
              <input type="text" placeholder="Enter Email address" />
            </div>
          </div>
        </div>
      </div>

      <div className="form-navigate-footer">
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
